"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterStaffForAccess = filterStaffForAccess;
exports.useSchedulingAccess = useSchedulingAccess;
var vue_1 = require("vue");
var vuex_1 = require("vuex");
var axios_1 = require("axios");
var apis_1 = require("@/constants/apis");
var privilegesApi_1 = require("@/api/privilegesApi");
var privileges_1 = require("@/stores/privileges");
var privileges_2 = require("@/constants/privileges");
// Mirrors WelcomeQuickNav.vue's isHealthcareProHomeGrid account-type list.
var HEALTHCARE_PRO_TYPES = {
    'provider': 'provider',
    'nurse': 'nurse',
    'registered nurse': 'nurse',
    'licensed practical nurse': 'nurse',
    'home health aid': 'hha',
    'home health aids': 'hha',
    'home health aide': 'hha',
    'home health aides': 'hha',
    'allied professional': 'allied',
    'allied professionals': 'allied',
};
function normalize(value) {
    return String(value || '').trim().toLowerCase();
}
/**
 * Restricts a staff/provider/nurse list to just the caller, for a locked
 * caregiver session -- a no-op for admin/patient access.
 *
 * WHY THIS EXISTS
 * Before this helper, ManageScheduling.vue and MasterCalendar.vue each
 * independently filtered their own staff lists by category only, never by
 * `access.kind` -- so a restricted caregiver's dropdown correctly *defaulted*
 * to their own name (selectedStaffId was already pinned to access.staffId)
 * but still *listed* every other nurse/HHA/provider in their category, and
 * nothing stopped manually picking someone else. Centralizing the fix here,
 * rather than patching each component's own computed list independently,
 * is deliberate -- that's exactly the kind of duplicated-and-partially-fixed
 * bug that caused the original gap. Every staff/provider/caregiver picker
 * across Scheduling should call this instead of filtering `store.providers`/
 * `store.nurses` itself.
 *
 * WHAT THIS IS NOT RESPONSIBLE FOR
 * - Patients: the patient list is already staff-scoped server-side via
 *   store.loadPatientsFromStaffPatientsGroup() (SqlClass::
 *   GetPatientsFromStaffPatientsGroup on the backend) -- there is no
 *   equivalent client-side leak to filter for patients, so this helper only
 *   ever narrows STAFF lists.
 * - Enforcement: this is a UX-correctness fix, not a security boundary --
 *   the actual authorization now happens server-side (SessionActor +
 *   AuthorizeSchedulingProviderActor/AuthorizeSchedulingAppointmentActor in
 *   keyon/). A bug here means a confusing dropdown, not a bypass; the
 *   backend gate is what actually prevents a restricted caregiver from
 *   acting on someone else's calendar even if this filter were removed.
 *
 * @param list   Any staff/provider/nurse array whose items carry an `id`
 *               matching SchedulingAccess['staffId'] (account_user.unique_ID).
 * @param access The current SchedulingAccess, or null/undefined while it's
 *               still resolving -- treated the same as a non-caregiver
 *               access kind (no filtering) so callers don't need a separate
 *               loading check before calling this.
 * @return The unfiltered list for 'admin'/'patient' access (or while access
 *         is still resolving); for 'caregiver' access, the list narrowed to
 *         the single entry whose `id` matches `access.staffId` (or empty if
 *         the caller isn't in the list at all).
 */
function filterStaffForAccess(list, access) {
    if ((access === null || access === void 0 ? void 0 : access.kind) === 'caregiver') {
        return list.filter(function (s) { return s.id === access.staffId; });
    }
    return list;
}
// Same "Administrators" group-inheritance check ManageScheduling.vue already
// uses for its own isAdmin computed.
function isAdminByGroup(privStore) {
    return privStore.assignments.some(function (row) {
        return (row.inherited_from_groups || []).some(function (g) {
            return String(g.name || '').toLowerCase().trim() === 'administrators';
        });
    });
}
// Same webhook call as WelcomeQuickNav.vue's loadWelcomeGridMeta.
function fetchAccountType(accountnumber, subaccountnumber) {
    return __awaiter(this, void 0, Promise, function () {
        var res, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.post("".concat(apis_1.CURR_API, "/tswebhook.php"), {
                            Account: { API_Meth: 'GetAccountType', accountnumber: accountnumber, subaccountnumber: subaccountnumber }
                        }, { headers: { 'Content-Type': 'application/json;' } })];
                case 1:
                    res = _c.sent();
                    return [2 /*return*/, ((_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.providerAssignment) === null || _b === void 0 ? void 0 : _b.accounttype) || ''];
                case 2:
                    e_1 = _c.sent();
                    console.error('useSchedulingAccess: GetAccountType failed', e_1);
                    return [2 /*return*/, ''];
                case 3: return [2 /*return*/];
            }
        });
    });
}
// Same webhook call as GroupsPage.vue's fetchOwnerGroups. Rows use `id`
// (not `group_id` — that field name is only used on privilege-assignment rows).
function fetchGroupsByOwner(accountnumber, ownerUniqueId) {
    return __awaiter(this, void 0, Promise, function () {
        var res, list, e_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1.default.post("".concat(apis_1.CURR_API, "/tswebhook.php"), {
                            Groups: { API_Meth: 'GetGroupsByOwner', accountnumber: accountnumber, owner_unique_ID: ownerUniqueId }
                        }, { headers: { 'Content-Type': 'application/json;' } })];
                case 1:
                    res = _b.sent();
                    list = Array.isArray((_a = res.data) === null || _a === void 0 ? void 0 : _a.data) ? res.data.data : [];
                    return [2 /*return*/, list.map(function (g) { return Number(g.id); }).filter(function (n) { return Number.isFinite(n); })];
                case 2:
                    e_2 = _b.sent();
                    console.error('useSchedulingAccess: GetGroupsByOwner failed', e_2);
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * Resolves how the current session should see the Scheduling module:
 * - admin: unrestricted (existing behavior).
 * - caregiver: a non-admin provider/nurse/hha/allied pro on their own dashboard.
 * - patient: a self-service patient login, or anyone (family/caregiver)
 *   currently viewing a patient chart — enterPatientChartAndRefresh replaces
 *   `allData.patient` with that patient's record, so this case
 *   can't be (and doesn't need to be) distinguished from a true self-login
 *   except via `allData.viewingPatientChart`, used below to gate `canAdd`.
 */
function useSchedulingAccess() {
    var vuex = (0, vuex_1.useStore)();
    var privStore = (0, privileges_1.usePrivilegesStore)();
    var allData = (0, vue_1.computed)(function () { return (vuex && vuex.getters ? vuex.getters['login/getAllData'] : {}); });
    var access = (0, vue_1.ref)(null);
    var loading = (0, vue_1.ref)(true);
    // PATIENT_SCHEDULING_ADD only counts when granted via a group owned by the
    // specific patient in view (not a blanket org-wide grant) — cross-reference
    // the privilege's inherited_from_groups against that patient's owned groups.
    function resolveCanAdd(accountnumber, patientUniqueId) {
        return __awaiter(this, void 0, Promise, function () {
            var row, grantedGroupIds, ownedGroupIds;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        row = privStore.rowById(privileges_2.PRIVILEGES.PATIENT_SCHEDULING_ADD);
                        if (!row || !row.effective_granted)
                            return [2 /*return*/, false];
                        if (row.user_override === 'grant')
                            return [2 /*return*/, true];
                        grantedGroupIds = (row.inherited_from_groups || [])
                            .map(function (g) { return Number(g.group_id); })
                            .filter(function (n) { return Number.isFinite(n); });
                        if (!grantedGroupIds.length)
                            return [2 /*return*/, false];
                        return [4 /*yield*/, fetchGroupsByOwner(accountnumber, patientUniqueId)];
                    case 1:
                        ownedGroupIds = _a.sent();
                        return [2 /*return*/, grantedGroupIds.some(function (id) { return ownedGroupIds.includes(id); })];
                }
            });
        });
    }
    function resolve() {
        return __awaiter(this, void 0, void 0, function () {
            var data, accountnumber, accounttype, normalized, category, unique_ID, key, patientId, firstName, lastName, patientName, canAdd, fullAccess, key, key;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return __generator(this, function (_o) {
                switch (_o.label) {
                    case 0:
                        loading.value = true;
                        data = allData.value || {};
                        accountnumber = (_a = data.patient) === null || _a === void 0 ? void 0 : _a.externId2;
                        if (!accountnumber) {
                            access.value = null;
                            loading.value = false;
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetchAccountType(accountnumber, (_b = data.patient) === null || _b === void 0 ? void 0 : _b.externId)];
                    case 1:
                        accounttype = _o.sent();
                        normalized = normalize(accounttype);
                        if (normalized === 'administrator') {
                            access.value = { kind: 'admin' };
                            loading.value = false;
                            return [2 /*return*/];
                        }
                        category = HEALTHCARE_PRO_TYPES[normalized];
                        if (!category) return [3 /*break*/, 4];
                        unique_ID = (0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(data).unique_ID;
                        key = "".concat(accountnumber, ":").concat(unique_ID);
                        if (!(privStore.loadedKey !== key)) return [3 /*break*/, 3];
                        return [4 /*yield*/, privStore.fetchForCurrentSession(data)
                            // A provider/nurse/HHA/allied pro granted this privilege gets
                            // admin-equivalent scheduling access (every calendar, schedule for
                            // anyone) without being made a full org Administrator.
                        ];
                    case 2:
                        _o.sent();
                        _o.label = 3;
                    case 3:
                        // A provider/nurse/HHA/allied pro granted this privilege gets
                        // admin-equivalent scheduling access (every calendar, schedule for
                        // anyone) without being made a full org Administrator.
                        if (privStore.effectiveGranted(privileges_2.PRIVILEGES.SCHEDULE_ADMINISTER)) {
                            access.value = { kind: 'admin' };
                            loading.value = false;
                            return [2 /*return*/];
                        }
                        access.value = { kind: 'caregiver', staffId: unique_ID, category: category };
                        loading.value = false;
                        return [2 /*return*/];
                    case 4:
                        patientId = String((_f = (_d = (_c = data.patient) === null || _c === void 0 ? void 0 : _c.mid) !== null && _d !== void 0 ? _d : (_e = data.patient) === null || _e === void 0 ? void 0 : _e.externId) !== null && _f !== void 0 ? _f : '');
                        firstName = ((_g = data.patient) === null || _g === void 0 ? void 0 : _g.first_name) || ((_h = data.patient) === null || _h === void 0 ? void 0 : _h.firstName) || '';
                        lastName = ((_j = data.patient) === null || _j === void 0 ? void 0 : _j.lastname) || ((_k = data.patient) === null || _k === void 0 ? void 0 : _k.lastName) || '';
                        patientName = "".concat(firstName, " ").concat(lastName).trim();
                        canAdd = false;
                        fullAccess = false;
                        if (!data.viewingPatientChart) return [3 /*break*/, 10];
                        key = "".concat(accountnumber, ":").concat((0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(data).unique_ID);
                        if (!(privStore.loadedKey !== key)) return [3 /*break*/, 6];
                        return [4 /*yield*/, privStore.fetchForCurrentSession(data)
                            // The clinician viewing the chart (the actual acting subject — resolveKeyonPrivilegeIdentity
                            // resolves to `manager` during patient chart viewing) keeps their own elevated
                            // access when stepping into a patient's chart: an org admin or a provider
                            // granted SCHEDULE_ADMINISTER can add/schedule for any patient, not just
                            // ones a per-patient PATIENT_SCHEDULING_ADD group grant covers.
                        ];
                    case 5:
                        _o.sent();
                        _o.label = 6;
                    case 6:
                        if (!(isAdminByGroup(privStore) || privStore.effectiveGranted(privileges_2.PRIVILEGES.SCHEDULE_ADMINISTER))) return [3 /*break*/, 7];
                        canAdd = true;
                        fullAccess = true;
                        return [3 /*break*/, 9];
                    case 7: return [4 /*yield*/, resolveCanAdd(accountnumber, String((_m = (_l = data.patient) === null || _l === void 0 ? void 0 : _l.externId) !== null && _m !== void 0 ? _m : ''))];
                    case 8:
                        canAdd = _o.sent();
                        _o.label = 9;
                    case 9: return [3 /*break*/, 13];
                    case 10:
                        key = "".concat(accountnumber, ":").concat((0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(data).unique_ID);
                        if (!(privStore.loadedKey !== key)) return [3 /*break*/, 12];
                        return [4 /*yield*/, privStore.fetchForCurrentSession(data)];
                    case 11:
                        _o.sent();
                        _o.label = 12;
                    case 12:
                        canAdd = privStore.effectiveGranted(privileges_2.PRIVILEGES.PATIENT_SCHEDULING_ADD);
                        _o.label = 13;
                    case 13:
                        access.value = { kind: 'patient', patientId: patientId, patientName: patientName, canAdd: canAdd, fullAccess: fullAccess };
                        loading.value = false;
                        return [2 /*return*/];
                }
            });
        });
    }
    // Re-resolve whenever the session snapshot changes — not just once on mount —
    // so this stays correct if `allData` populates asynchronously after this
    // composable is first set up, or changes while mounted (e.g. patient chart viewing
    // starting/ending without a full page reload).
    (0, vue_1.watch)(allData, resolve, { immediate: true, deep: true });
    return { access: access, loading: loading, refresh: resolve };
}
